import { Box, MenuItem, Paper, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../App/Components/Navigation/Subcomponents/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "../../App/Components/PageContainer/PageContainer";
import { PageTitle } from "../../App/Components/PageTitle/PageTitle";
import { useManagementClients } from "../../App/Queries/ClientQueries";
import { DirectDelete } from "./DeleteCandidates/DirectDelete";
import SearchAndDelete from "./DeleteCandidates/SearchAndDelete";
import { DeleteCandidateState, DeleteType } from "./DeleteCandidates/State/DeleteCandidateState";

export default function AdminDeleteCandidates() {
  const [selectedClientId, setSelectedClientId] = useState<string>("None");
  const navigate = useNavigate();
  const { data: clients = [], isLoading } = useManagementClients();

  useEffect(() => {
    if (!isLoading && (!clients || clients.length <= 0)) {
      navigate("/");
    }
  }, [clients, isLoading, navigate]);

  const selectedClient =
    selectedClientId === "None" ? undefined : clients.find((c) => c.clientId === selectedClientId);

  const state = DeleteCandidateState(selectedClient);

  return (
    <PageContainer>
      <Breadcrumbs pageTitle="Candidates" />
      <PageTitle>Delete Candidates</PageTitle>
      <Paper sx={{ mt: { xs: 1, md: 2 }, p: { xs: 2, lg: 4 } }}>
        <Stack direction="row" spacing={2} alignItems="center" width="100%">
          <TextField
            id="client-select"
            select
            label="Select Client"
            defaultValue="None"
            sx={{ width: 300 }}
            onChange={(ev) => setSelectedClientId(ev.target.value)}
          >
            <MenuItem key={"None"} value={"None"}>
              None
            </MenuItem>
            {clients.length > 0 &&
              clients.map((option) => (
                <MenuItem key={option.clientId} value={option.clientId}>
                  {option.clientName}
                </MenuItem>
              ))}
          </TextField>
          <Box>
            <TextField
              id="delete-type"
              select
              label="Delete Type"
              defaultValue={DeleteType.SearchAndDelete}
              fullWidth
              sx={{ width: 300 }}
              onChange={state.effects.handleChangeDeleteType}
            >
              <MenuItem key={DeleteType.SearchAndDelete} value={DeleteType.SearchAndDelete}>
                Search and Delete
              </MenuItem>
              <MenuItem key={DeleteType.DirectDelete} value={DeleteType.DirectDelete}>
                Direct Delete
              </MenuItem>
            </TextField>
          </Box>
          <Typography data-test="delete-type-copy" variant="caption" sx={{ width: "80ch", maxWidth: "100%" }}>
            {state.getters.deleteType === DeleteType.SearchAndDelete
              ? "Search and filter candidates, select them by clicking on the row or using the checkbox."
              : "Input a list of candidate IDs to be deleted."}
            <br />
            Delete the selected candidates by clicking the Delete Candidates button.
          </Typography>
        </Stack>
        <Stack direction="column" spacing={2} sx={{ mt: 3 }}>
          {selectedClient && state.getters.deleteType === DeleteType.SearchAndDelete && (
            <SearchAndDelete state={state} />
          )}
          {selectedClient && state.getters.deleteType === DeleteType.DirectDelete && (
            <DirectDelete state={state} />
          )}
        </Stack>
      </Paper>
    </PageContainer>
  );
}
